(function ($) {
    "use strict";

    // The native <select>'s own open dropdown list is rendered by the OS/
    // browser and can't be styled consistently cross-browser, so it gets
    // progressively enhanced here into a custom button + listbox. The
    // native element is kept (visually hidden) purely to carry the
    // name/value for form submission.
    function enhanceSelect($wrap) {
        var $select = $wrap.find(".pm-property-filter__select");

        if (!$select.length || $wrap.data("pm-select-enhanced")) {
            return;
        }

        $wrap.data("pm-select-enhanced", true);

        var $chevron = $wrap.find(".pm-property-filter__select-chevron").detach();
        var $triggerLabel = $("<span>", { class: "pm-property-filter__select-trigger-label" });
        var $trigger = $("<button>", {
            type: "button",
            class: "pm-property-filter__select-trigger",
            "aria-haspopup": "listbox",
            "aria-expanded": "false",
        }).append($triggerLabel, $chevron);

        var $list = $("<ul>", {
            class: "pm-property-filter__select-list",
            role: "listbox",
        }).attr("hidden", true);

        $select.find("option").each(function () {
            var $option = $(this);
            var $item = $("<li>", {
                class: "pm-property-filter__select-option",
                role: "option",
                tabindex: "-1",
                text: $option.text(),
            }).attr("data-value", $option.attr("value"));

            if ($option.is(":selected")) {
                $item.addClass("is-selected");
                $triggerLabel.text($option.text());
            }

            $list.append($item);
        });

        $select
            .attr("tabindex", "-1")
            .attr("aria-hidden", "true")
            .addClass("pm-property-filter__select--native-hidden");

        $wrap.append($trigger, $list);

        function closeList() {
            $list.attr("hidden", true);
            $trigger.attr("aria-expanded", "false");
        }

        function openList() {
            $(".pm-property-filter__select-list").not($list).attr("hidden", true);
            $(".pm-property-filter__select-trigger").not($trigger).attr("aria-expanded", "false");
            $list.removeAttr("hidden");
            $trigger.attr("aria-expanded", "true");
        }

        function selectOption($item) {
            $list.find(".is-selected").removeClass("is-selected");
            $item.addClass("is-selected");
            $triggerLabel.text($item.text());
            $select.val($item.attr("data-value")).trigger("change");
        }

        $trigger.on("click", function (e) {
            e.stopPropagation();

            if ($list.attr("hidden")) {
                openList();
                var $selected = $list.find(".is-selected");
                ($selected.length ? $selected : $list.find(".pm-property-filter__select-option").first()).trigger("focus");
            } else {
                closeList();
            }
        });

        $list.on("click", ".pm-property-filter__select-option", function () {
            selectOption($(this));
            closeList();
            $trigger.trigger("focus");
        });

        $list.on("keydown", ".pm-property-filter__select-option", function (e) {
            var $items = $list.find(".pm-property-filter__select-option");
            var index = $items.index(this);

            if (e.key === "ArrowDown") {
                e.preventDefault();
                $items.eq(Math.min(index + 1, $items.length - 1)).trigger("focus");
            } else if (e.key === "ArrowUp") {
                e.preventDefault();
                $items.eq(Math.max(index - 1, 0)).trigger("focus");
            } else if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                selectOption($(this));
                closeList();
                $trigger.trigger("focus");
            } else if (e.key === "Escape") {
                e.preventDefault();
                closeList();
                $trigger.trigger("focus");
            } else if (e.key === "Tab") {
                closeList();
            }
        });

        $trigger.on("keydown", function (e) {
            if (e.key === "ArrowDown" || e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                openList();
                var $selected = $list.find(".is-selected");
                ($selected.length ? $selected : $list.find(".pm-property-filter__select-option").first()).trigger("focus");
            }
        });
    }

    $(function () {
        var $toggle = $(".js-pm-property-filter-toggle");

        if (!$toggle.length) {
            return;
        }

        $(".pm-property-filter__select-wrap").each(function () {
            enhanceSelect($(this));
        });

        $(document).on("click", function () {
            $(".pm-property-filter__select-list").attr("hidden", true);
            $(".pm-property-filter__select-trigger").attr("aria-expanded", "false");
        });

        $toggle.on("click", function () {
            var $detailed = $(this)
                .closest(".pm-property-filter__card")
                .find(".js-pm-property-filter-detailed");
            var isOpen = $detailed.toggleClass("is-open").hasClass("is-open");

            $(this).attr("aria-expanded", isOpen);
        });

        // Real search/filtering will be wired up once a real listings data
        // source exists — for now "Mégsem" just collapses the panel again.
        $(".js-pm-property-filter-cancel").on("click", function () {
            var $card = $(this).closest(".pm-property-filter__card");

            $card.find(".js-pm-property-filter-detailed").removeClass("is-open");
            $card.find(".js-pm-property-filter-toggle").attr("aria-expanded", false);
        });
    });
})(jQuery);
